export default [
  {
    disableDefaultUI: false,
  },
];
